import baseButtons from '@elegantstack/flow-ui-theme/src/theme/buttons'

// from solid-ui (used for unifying header and footer)
import secondary from '@solid-ui-theme/buttons/secondary'

const buttons = {
  ...baseButtons,
  secondary
}

export default buttons
